import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { Grid, Segment, Button } from 'semantic-ui-react'
import moment from 'moment'
import { loadingActions } from 'loankeeper-common/components/hocs/LazyLoading'
import transformProps from 'loankeeper-common/containers/transformProps'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { dateTime } from 'loankeeper-common/helpers/formatters'
import { translate as trans } from 'loankeeper-common/helpers'
import { withLivedata, withUserConfig } from 'shared'
//@ts-ignore
import FormField from 'shared/newFormElements'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKPeriodButton from 'shared/LKPeriodButton'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'
//@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
import {
  SegmentGroup,
  FlexTableChild,
  TableContainer,
  GridContainer,
  ComponentContainer,
  //@ts-ignore
} from 'shared/StyledComponents'
import LKGrid from '../shared/LKGrid'
// import { Reporting } from '../../WebAPI'
import * as Reporting from '../../store/reporting'
import { loanSearch } from '../../store/loan'
import { loadHypothecCollaterals as collateralSearch } from '../../store/collateral'
// import withFetcher from '../shared/containers/withFetcher'
import { actions as DCActions } from '../DetailsContainer'
import { getBackendUrl } from '../../store/config'
import { generate as generateReport, reportsView } from '../../store/reporting'
import { accountSearch } from 'src/store/account'
import { applicationSearch } from 'src/store/application'
import { DetailsReportingTabProps, generateReportParams, DetailsReportingTabState } from '../ClientDetails/types'
import { AppDispatch } from 'src/store/index.d'
import { clientSearch } from 'src/store/client'
import withFetcherHoc from '../shared/containers/withFetcherNew'

const translate = (key: string): string => trans(`frm_creports-${key}`)
const translateLKMessage = (key: string): string => trans(`LKMESSAGE-${key}`)
const translateFrm = (key: string): string => trans(`frm_web_messages-${key}`)

const TranslateExcel = (key: string): string => trans(`frm_Main-${key}`)

const dateTimeFormatter = (value: moment.MomentInput) =>
  dateTime(moment(value).format('YYYY-MM-DDTHH:mm:ss')).toString()
const dateFormatter = (value: moment.MomentInput) => LKDate.from(moment(value).format('YYYY-MM-DDTHH:mm:ss')).toString()

const getGridConfig = ({ customID }) => ({
  gridIdentity: {
    formName: 'frm_creports',
    objectName: 'dbgrd_repgeneral',
    customID,
  },

  columnConfigs: {
    ClientRegDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    OrgRegDate: {
      valueFormatter: ({ value }) => dateTimeFormatter(value),
    },
    CollateralOwnerDOB: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    StartDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    RegDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    InsuranceExpire: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    InsuranceDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    EndDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CollateralOwnerOrgRegDate: {
      valueFormatter: ({ value }) => dateTime(value),
    },
    CollateralOwnerIDCardValidityDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CollateralOwnerIDCardRegDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CreateDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    DocDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    OperDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    AppRegDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    IDValidityDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    IDCardRegDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    LastActiveOfficerDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    DOB: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CoverDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    DisburseDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    VisaDate: {
      valueFormatter: ({ value }) => dateTimeFormatter(value),
    },
    OpenDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    CloseDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
    Amount: {
      valueFormatter: ({ value }) =>
        value !== ''
          ? parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          : '',
      cellStyle: {
        textAlign: 'right',
      },
    },
    OSBalance: {
      valueFormatter: ({ value }) =>
        value !== ''
          ? parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
          : '',
      cellStyle: {
        textAlign: 'right',
      },
    },
  },

  syncGridState: true,
  enableRowSelection: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  showCellFocus: true,
  enableFilter: true,
  enableSorting: true,
})

@withRouter
//@ts-ignore
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDayStr', 'OpenDayStatus.Cur_Date as CurrentDate'])
@withUserConfig(['LocalCCY', 'ID as UserID', 'NodeID'])
@transformProps((props) => ({
  ...props,
  fetcherName: `DetailsReports-${props.type}`,
  APICall: Reporting[`view${props.type}`],
}))
//@ts-ignore
// @withFetcher({
//   getDataFromResponse: (data) => ({ reportsUDR: data.Data }),
//   withLoading: true,
// })
//UPDATED API REQUEST udr_view_api action: viewclient, viewapp, viewloan
@withFetcherHoc({
  getDataFromResponse: (data) => ({ reportsUDR: data }),
  withLoading: true,
})
@transformProps((props) => ({
  ...props,
  form: `Reporting-${props.type}-${props.ID}`,
  initialValues: {
    startDate: props.OpenDayStr,
    endDate: props.OpenDayStr,
    ReportID: props.reportsUDR.length && props.reportsUDR[0].ID,
  },
}))
//@ts-ignore
@reduxForm({
  destroyOnUnmount: false,
})
@transformProps((props) => ({
  ...props,
  form: `Reporting-${props.type}-${props.ID}`,
}))
//@ts-ignore
@connect(
  (state: any, props: { form: any }) => ({
    backendUrl: getBackendUrl(state),
    ReportID: formValueSelector(props.form)(state, 'ReportID'),
    startDate: formValueSelector(props.form)(state, 'startDate'),
    endDate: formValueSelector(props.form)(state, 'endDate'),
    Idents: formValueSelector(props.form)(state, 'Idents'),
    STK: state.persisted.session.STK,
  }),
  //@ts-ignore
  (dispatch, { change, OpenDayStr, ID, type, data }) => ({
    setOpenDay: () => {
      change('startDate', OpenDayStr)
      change('endDate', OpenDayStr)
    },
    setData: (reportId: string, reportData: any) =>
      dispatch(DCActions.fetchSuccess({ page: 'reports', data: { ...data, [reportId]: reportData }, type, ID })),
    openError: (message: string) => dispatch(LKModalActions.openError(message)),
    //@ts-ignore
    accountSearch: (params: { StatusID: string | number; Title: string }) => dispatch(accountSearch(params)),
    //@ts-ignore
    applicationSearch: (params: {
      searchfield: string
      searchflags: string
      searchvalue: string
      appregdate: string
      //@ts-ignore
    }) => dispatch(applicationSearch(params)),
    //@ts-ignore
    loanSearch: (params: { searchfield: string; searchflags: string; searchvalue: string }) =>
      //@ts-ignore
      dispatch(loanSearch(params)),
    //@ts-ignore
    generateReport: (params: generateReportParams) => dispatch(generateReport(params)),
    //@ts-ignore
    reportsView: (params: { action: string; Ident: any }) => dispatch(reportsView(params)),
    //@ts-ignore
    collateralSearch: (params: { searchfield: string; searchflags: string; searchvalue: string }) =>
      //@ts-ignore
      dispatch(collateralSearch(params)),
  }),
)
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  clientSearch: (params) => dispatch(clientSearch(params)),
}))
class DetailsReporting extends React.Component<DetailsReportingTabProps, DetailsReportingTabState> {
  cancelCheckStatus: number
  stringifyGrid = (arr) => {
    let r
    let rlen
    let c
    let clen
    let str = ''
    let val

    for (r = 0, rlen = arr.length; r < rlen; r += 1) {
      for (c = 0, clen = arr[r].length; c < clen; c += 1) {
        if (c > 0) {
          str += '\t'
        }

        val = arr[r][c]

        if (typeof val === 'string') {
          str += val.indexOf('\n') > -1 ? `"${val.replace(/"/g, '""')}"` : val
        } else if (val === null || val === undefined) {
          str += ''
        } else {
          str += val
        }
      }
      str += '\n'
    }
    return str
  }

  handleExcelExport = (api) => {
    api.exportDataAsExcel()
  }

  handleBufferExport = (api) => {
    api.selectAll()
    api.copySelectedRowsToClipboard(true)
    api.deselectAll()
  }

  getContextMenuItems = ({
    node: {
      data: { ClientID, LoanID, AppID, CollID, CollateralID, AccountID, AccID, EntryID, LBID },
    },
    api,
  }) => {
    const items = []
    if (ClientID) {
      items.push({
        name: translate('mnu_client'),
        action: async () => {
          const params = {
            searchfield: 'name',
            searchflags: '1110001',
            searchvalue: `#${ClientID}`,
          }
          // const { Data: Clients } = await Client.search(params)
          //UPDATED API REQUEST 'client_search'
          const { payload: Clients } = await this.props.clientSearch(params)

          if (Clients && Clients.length) {
            const { ID, HashSum_ClientID_, ClientType } = Clients[0]
            this.props.history.push(`/secure/client/${ID}/details/${HashSum_ClientID_}/${ClientType}`)
          }
        },
        permissionKey: 'VIEW_CLIENT',
        icon: 'info',
      })
    }

    if (LoanID) {
      items.push({
        name: translate('mnu_loan'),
        action: async () => {
          const { payload: Loans } = await this.props.loanSearch({
            searchfield: 'name',
            searchflags: '0000000',
            searchvalue: `#${LoanID}`,
          })

          if (Loans && Loans.length) {
            this.props.history.push(`/secure/loan/${Loans[0].ID}/details/${Loans[0].HashSum_LoanID_}`)
          }
        },
        permissionKey: 'VIEW_LOAN',
        icon: 'info',
      })
    }

    if (AppID) {
      items.push({
        name: translate('mnu_application'),
        action: async () => {
          const { payload: Apps } = await this.props.applicationSearch({
            searchfield: 'name',
            searchflags: '100000000',
            appregdate: '01.01.2001',
            searchvalue: `#${AppID}`,
          })
          if (Apps && Apps.length) {
            this.props.history.push(`/secure/application/${Apps[0].ID}/details/${Apps[0].HashSum_AppID_}`)
          }
        },
        permissionKey: 'VIEW_APPLICATION',
        icon: 'info',
      })
    }

    const CollatID = CollID || CollateralID

    if (CollatID) {
      items.push({
        name: translate('mnu_collateral'),
        action: async () => {
          const result = await this.props.collateralSearch({
            searchfield: 'name',
            searchflags: '10000011111111',
            searchvalue: `#${CollatID}`,
          })

          if (!collateralSearch.fulfilled.match(result)) {
            return
          }

          const Data = result.payload
          //@ts-ignore
          if (Data && Data.length) {
            this.props.history.push(
              `/secure/collateral/${Data[0].ID}/details/${Data[0].HashSum_CollateralID_}/${Data[0].TypeID}`,
            )
          }
        },
        permissionKey: 'VIEW_COLLATERAL',
        icon: 'info',
      })
    }

    const AcctID = AccountID || AccID

    if (AcctID) {
      items.push({
        name: translate('mnu_account'),
        action: async () => {
          const { payload: Data } = await this.props.accountSearch({
            StatusID: 0,
            Title: `#${AcctID}`,
          })

          if (Data && Data.length) {
            this.props.history.push(`/secure/account/${Data[0].ID}/details/${Data[0].HashSum_AccountID_}`)
          }
        },
        icon: 'info',
      })
    }

    items.push({
      name: TranslateExcel('lbl_exp_excel'),
      action: () => {
        this.handleExcelExport(api)
      },
      icon: 'export',
      permissionKey: 'EXPORT_DATA',
    })

    items.push({
      name: TranslateExcel('lbl_exp_clip'),
      action: () => {
        this.handleBufferExport(api)
      },
      icon: 'buffer',
      permissionKey: 'EXPORT_DATA',
    })

    return items
  }

  get type() {
    return this.props.type === 'Application' ? 'App' : this.props.type
  }

  handleCalc = async () => {
    this.setState({ reportFetching: true })

    //@ts-ignore
    loadingActions.start({ showTimer: true })

    const stopLoading = () => {
      loadingActions.stop()
      this.setState({ reportFetching: false })
    }

    try {
      const reportResponse = await this.props.generateReport({
        action: 'generate',
        ReportID: this.props.ReportID,
        HashSum_ReportID_: this.props.reportsUDR.find((r) => r.ID === this.props.ReportID).HashSum_ReportID_,
        CalcDate: this.props.startDate,
        CalcDate2: this.props.endDate,
        CCY: this.props.LocalCCY,
        SEC_UserID: this.props.UserID,
        NodeID: this.props.NodeID,
        [`${this.type}ID`]: this.props.ID,
        [`HashSum_${this.type}ID_`]: this.props.hash,
      })

      if (!generateReport.fulfilled.match(reportResponse)) {
        stopLoading()
        return
      }

      const Ident = reportResponse.payload

      let status = {
        payload: {
          StatusID: 1,
        },
      }

      /* eslint-disable no-await-in-loop */
      while (status.payload.StatusID < 3) {
        if (this.cancelCheckStatus === 2) {
          return
        }

        const currentDateTime = moment(this.props.CurrentDate).add(1, 's')
        status = await this.props.reportsView({
          action: 'status',
          Ident,
        })
        //@ts-ignore
        if (!reportsView.fulfilled.match(status)) {
          stopLoading()
          return
        }
        //@ts-ignore
        if (!moment.unix(status.payload.ExpireInPrTS).isAfter(currentDateTime)) {
          // eslint-disable-next-line no-throw-literal
          throw {
            Error: {
              Message: translateFrm('ERR_WAITING_TIMEOUT'),
            },
          }
        }
        //@ts-ignore
        if (!moment.unix(status.payload.ExpireNewTS).isAfter(currentDateTime) && status.payload.StatusID === 1) {
          // eslint-disable-next-line no-throw-literal
          throw {
            Error: {
              Message: translateFrm('ERR_WAITING_TIMEOUT'),
            },
          }
        }
        //@ts-ignore
        if (!status.payload.ExpireNewTS || status.payload.ExpireNewTS === 0) {
          // eslint-disable-next-line no-throw-literal
          throw {
            Error: {
              Text: translateFrm('ERROR'),
            },
          }
        }
      }

      if (status.payload.StatusID === 3) {
        this.props.openError(translateLKMessage('HINT_ERR_TITLE'))
      } else if (status.payload.StatusID === 5) {
        const { payload: error } = await this.props.reportsView({
          action: 'viewerror',
          Ident,
        })

        this.props.openError(error)
      } else if (status.payload.StatusID === 4) {
        const reportsViewResult = await this.props.reportsView({
          action: 'view',
          Ident,
        })

        if (!reportsView.fulfilled.match(reportsViewResult)) {
          stopLoading()
          return
        }

        const dataUDR = reportsViewResult.payload

        this.props.setData(this.props.ReportID, dataUDR)
        this.props.change('Idents', { ...this.props.Idents, [this.props.ReportID]: Ident })
      }
    } catch (e) {
      this.props.openError((e && e.Error && (e.Error.Message || e.Error.Text)) || translateLKMessage('HINT_ERR_TITLE'))
    } finally {
      stopLoading()
    }
  }

  render() {
    const { reportsUDR, type } = this.props
    const report = this.props.reportsUDR.find((r) => r.ID === this.props.ReportID)
    const isStartDateDisabled = report?.DateRangeEnabled === 2
    return (
      <SegmentGroup>
        <Segment.Group>
          <Segment>
            <GridContainer>
              <Grid>
                <Grid.Row>
                  {/* Calculate */}
                  <Grid.Column width={6}>
                    <GridContainer>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={8} textAlign="right" verticalAlign="middle">
                            <ComponentContainer dropdown>
                              <FormField type="select" name="ReportID" fluid options={reportsUDR} />
                            </ComponentContainer>
                          </Grid.Column>

                          <Grid.Column width={8} textAlign="left" verticalAlign="middle">
                            <LKButton alias="chip" size="tiny" onClick={this.handleCalc}>
                              {translate('cmd_recalc')}
                            </LKButton>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </GridContainer>
                  </Grid.Column>

                  <Grid.Column width={7} className="u-flexAlignCenter">
                    <div className="u-fluid u-flexAlignCenter">
                      <div className="u-fluid u-flexAlignCenter">
                        <span className="u-marginRight-5">Date(s)</span>

                        <FormField
                          type="range-date-picker-first-input"
                          name="startDate"
                          disabled={isStartDateDisabled}
                        />
                      </div>

                      <Button.Group className="u-marginLeft-5 u-marginRight-5" icon>
                        <LKPeriodButton startDateName="startDate" endDateName="endDate" change={this.props.change} />

                        <LKButton alias="pin" onClick={this.props.setOpenDay} />
                      </Button.Group>

                      <div className="u-fluid">
                        <FormField
                          form={this.props.form}
                          startDateName="startDate"
                          endDateName="endDate"
                          type="range-date-picker"
                        />
                      </div>
                    </div>
                  </Grid.Column>

                  <Grid.Column width={3} textAlign="right" verticalAlign="middle">
                    <LKPrintButton
                      name={translate('cmd_print')}
                      //@ts-ignore
                      disabled={!this.props.data[this.props.ReportID] || !this.props.data[this.props.ReportID]?.length}
                      type={LKPrintButtonConstants.types.reporting}
                      ID={this.props.ReportID}
                      hash={report && report.HashSum_ReportID_}
                      extraParams={{
                        CalcDate: this.props.startDate,
                        CalcDate2: this.props.endDate,
                        CCY: this.props.LocalCCY,
                        SEC_UserID: this.props.UserID,
                        NodeID: this.props.NodeID,
                        [`${this.type}ID`]: this.props.ID,
                        [`HashSum_${this.type}ID_`]: this.props.hash,
                      }}
                      page="printudr"
                      left
                    />

                    <LKGridExportButton size="tiny" />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Segment>

          <FlexTableChild>
            <TableContainer borderTop>
              <LKGrid
                instanceName={`Reporting-${this.props.type}-${this.props.ID}`}
                {...getGridConfig({ customID: `${type}-${this.props.ReportID}` })}
                getContextMenuItems={this.getContextMenuItems}
                rowData={this.props.data[this.props.ReportID]}
                isApplyGeneralNumberFormat
              />
            </TableContainer>
          </FlexTableChild>
        </Segment.Group>
      </SegmentGroup>
    )
  }
}

export default DetailsReporting
